import React from 'react'
import { connect } from 'dva'
import { framework_tool, component_tool, utils_tool } from '@/tool'
import { modelUtils } from '@/utils'
import moment from 'moment'
const { WizSpin, WizCard, WizForm, WizRow, WizCol, WizButton, WizGallery } = component_tool
const { WizContainer } = framework_tool
const { Session } = utils_tool

const findParamRecord = (history) => {
    let record = {}
    if (history.location && history.location.pathname === '/integrationCounseling/manager/antecedentIntervention/callCar/examine') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('callCarExamine', record)
        } else {
            record = Session.get('callCarExamine') || {}
        }
    }
    if (history.location && history.location.pathname === '/integrationCounseling/manager/antecedentIntervention/callAccessories/examine') {
        if (history.location && history.location.record) {
            record = history.location.record
            Session.set('callAccessoriesExamine', record)
        } else {
            record = Session.get('callAccessoriesExamine') || {}
        }
    }
    return record
}

class SalesOpeningExamine extends WizContainer {

    componentName = 'SalesOpeningExamine'

    constructor(props) {
        super(props)
        let record = findParamRecord(props.history)
        this.state = {
            record,
            visible: false,
            index: 0
        }
    }

    _componentDidMount() {
        this._detail()
    }

    _detail = () => {
        const { recordId } = this.state.record
        this.doAction({
            path: 'counselingProcess/callCarDetail',
            payload: {
                key: 'callCarDetail@' + recordId,
                apiParams: {
                    id: recordId
                }
            }
        })
    }

    _onSub = () => {
        const { recordId } = this.state.record
        this.refs.form.validateFields((err, values) => {
            if (!err) {
                let { state, remark } = values
                let params = {
                    state,
                    remark,
                    id: recordId
                }
                this.doAction({
                    path: 'counselingProcess/callCarCheck',
                    payload: {
                        key: 'callCarCheck@' + recordId,
                        apiParams: params
                    }
                })
            }
        })
    }

    propsAndStateOnChange = {
        save: this._saveOnChange.bind(this)
    }

    _saveOnChange(nextProps, nextState) {
        if (nextProps.save.code === 1) {
            wizNotice.success('操作成功')
            this.jumpPage('goBack')
        } else {
            wizNotice.error(nextProps.save.msg)
        }
    }

    _renderFooter = () => {
        return (
            <WizRow className='form-btns row-item'>
                <WizCol span={24}>
                    <WizButton type='primary' onClick={() => this._onSub()}>{'确认'}</WizButton>
                </WizCol>
            </WizRow>
        )
    }

    render() {
        let { detail, counselingProcessLoading } = this.props
        let { visible, index, record } = this.state
        const { moduleType } = record
        let infoProps = {
            ref: 'info',
            columns: [{
                title: `首次${moduleType === 0 ? '拷车' : '拷配件'}日期`,
                name: 'submitTime',
                dataIndex: 'submitTime',
                formItem: {
                    type: 'custom',
                    render: (r, f) => r && r.submitTime ? moment(r.submitTime).format('YYYY-MM-DD') : ''
                }
            }, {
                title: `首次${moduleType === 0 ? '拷车' : '拷配件'}截图`,
                name: 'fileIds',
                dataIndex: 'fileIds',
                formItem: {
                    type: 'custom',
                    render: (r, f) => {
                        let fileIds = r && r.fileIds ? r.fileIds : []
                        let imgs = fileIds.map((fileId, index) => getOssFilePath(fileId))
                        return (
                            <div style={{ display: 'flex', 'flex-wrap': 'wrap' }}>
                                {imgs.map((img, index) => {
                                    return (
                                        <div key={'callCarImg_', index} style={{ padding: 8 }}>
                                            <img height={80} width={80} src={img} onClick={() => this.setState({ visible: true, index })} />
                                        </div>
                                    )
                                })}
                                <WizGallery
                                    visible={visible}
                                    sources={imgs}
                                    index={index}
                                    onCancel={() => this.setState({ visible: false })}
                                />
                            </div>
                        )
                    }
                }
            }],
            record: detail.data,
            preview: null,
            footer: null,
            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 17 }
            },
            style: { maxWidth: '100%', width: '100%' }
        }

        let columns = [{
            title: '审核结果',
            name: 'state',
            dataIndex: 'state',
            dict: [
                { code: 0, codeName: '不合格' },
                { code: 1, codeName: '合格' }
            ],
            formItem: {
                type: 'select',
                style: { maxWidth: 300 },
                rules: [{ required: true, message: '请选择审核结果' }]
            }
        }, {
            title: '审核意见',
            name: 'remark',
            dataIndex: 'remark',
            formItem: {
                type: 'textarea',
                maxLength: 100,
                autoSize: { minRows: 4, maxRows: 8 },
                rules: [{ required: true, message: '请输入审核意见' }]
            }
        }]
        let formProps = {
            ref: 'form',
            columns,
            record: detail.data,
            preview: null,
            footer: this._renderFooter(),
            formItemLayout: {
                labelCol: { span: 4 },
                wrapperCol: { span: 17 }
            },
            style: { maxWidth: '100%', width: '100%' }
        }
        return (
            <WizSpin spinning={counselingProcessLoading} >
                <WizCard title={`首次${moduleType === 0 ? '拷车' : '拷配件'}`}>
                    <WizForm {...infoProps} />
                </WizCard>
                <WizCard title='审核'>
                    <WizForm {...formProps} />
                </WizCard>
            </WizSpin>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    const { counselingProcess } = state
    const { recordId } = findParamRecord(ownProps.history)
    const detail = modelUtils.getModelEntity(counselingProcess, 'callCarDetail@' + recordId)
    const save = modelUtils.getModelEntity(counselingProcess, 'callCarCheck@' + recordId)
    const loading = modelUtils.getLoadingState(state, 'counselingProcess')
    return {
        detail,
        save,
        ...loading
    }
}

export default connect(mapStateToProps)(SalesOpeningExamine)


